import { Breakpoint } from './types';

const size = {
    mobileS: 360,
    mobileM: 440,
    mobileL: 600,
    tablet: 768,
    laptopS: 1024,
    laptopM: 1280,
    laptopL: 1440,
    desktop: 2560
};

export const breakpoints: { [key in Breakpoint]: number } = {
    '3xs': size.mobileS - 1,
    '2xs': size.mobileM - 1,
    'xs': size.mobileL - 1,
    'sm': size.tablet - 1,
    'md': size.laptopS - 1,
    'lg': size.laptopM - 1,
    'xl': size.laptopL - 1,
    '2xl': size.desktop - 1
};

export const device = {
    mobileS: `(max-width: ${breakpoints['3xs']}px)`,
    mobileM: `(max-width: ${breakpoints['2xs']}px)`,
    mobileL: `(max-width: ${breakpoints['xs']}px)`,
    tablet: `(max-width: ${breakpoints['sm']}px)`,
    laptopS: `(max-width: ${breakpoints['md']}px)`,
    laptopM: `(max-width: ${breakpoints['ls']}px)`,
    laptopL: `(max-width: ${breakpoints['xl']}px)`,
    desktop: `(max-width: ${breakpoints['2xl']}px)`
};
